import { server } from "../utils/server";

const getInvested = async (userId) => {
    return server.get(`/investor/leads/invested/${userId}`,)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const all = async (userId) => {
    return server.get(`/investor/leads/all/${userId}`,)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const sendEmailInvites = async (data) => {
    return server.post("/investor/leads/send-email-invites", data)
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}

const activeCampaigns = async () => {
    return server.get("/investor/leads/active-campaign")
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}

export const investorLeads = {
    getInvested,
    all,
    sendEmailInvites,
    activeCampaigns,
};